import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import TableContainer from '@material-ui/core/TableContainer';
import cn from 'classnames';
import { observer } from 'mobx-react';
import React, { FC, useCallback } from 'react';

import { COLORS, makeStyles } from '~/@components/@theme';
import { LocalizableText } from '~/@components/LocalizableText';
import { homePageMapStore, IHomePageLandfill } from '~/@user-store/homePageMap';

import { Card } from '../Card';

export const OwnLandfills: FC = observer(() => {
    const onSelect = useCallback((landfill: IHomePageLandfill) => {
        homePageMapStore.onLandfillClick(landfill);
    }, []);

    const { noData, root, header, row, even, selected } = useStyles();

    if (!homePageMapStore.ownLandfillDistances) return null;

    if (homePageMapStore.ownLandfillDistances.length === 0)
        return (
            <div className={noData}>
                <LocalizableText code={'PoiInfoPanel.noOwnLandfills'} />
            </div>
        );

    return (
        <Card>
            <TableContainer className={root}>
                <Table size={'small'} stickyHeader>
                    <TableHead>
                        <TableRow className={header}>
                            <TableCell align={'left'}>
                                <LocalizableText code={'PoiInfoPanel.landfill'} />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {homePageMapStore.ownLandfillDistances.map((l, i) => (
                            <TableRow
                                key={l.landfill.id}
                                className={cn(row, {
                                    [even]: i % 2 === 0,
                                    [selected]: l.landfill.id === homePageMapStore.selectedLandfill?.id,
                                })}
                                onClick={() => onSelect(l.landfill)}>
                                <TableCell align={'left'}>{l.landfill.name}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Card>
    );
});

const useStyles = makeStyles(() => ({
    noData: {
        display: 'flex',
        justifyContent: 'center',
        fontSize: '18px',
    },
    root: {
        maxHeight: '240px',
        '& .MuiTableCell-root': {
            fontSize: '14px',
            height: '40px',
        },
    },
    header: {
        '& .MuiTableCell-head': {
            color: COLORS.white,
            backgroundColor: COLORS.brandMain,
        },
    },
    row: {
        '& .MuiTableCell-root': {
            borderBottom: 'none',
            cursor: 'pointer',
        },
    },
    even: {
        '& .MuiTableCell-root': {
            background: COLORS.grayLight,
        },
    },
    selected: {
        '& .MuiTableCell-root': {
            background: COLORS.blueLight,
        },
    },
}));
